import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import HomeActions from "../../../Redux/Home/action";
import HTMLRenderer from "react-html-renderer";

export default function TermsandCondition() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const { websiteLanguages, currentLanguage } = useSelector(
    (state) => state.commonReducer
  );
  const { PrivacyPolicy } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentYear(new Date().getFullYear());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // if (localStorage.getItem("token") && localStorage.getItem("auth_user")) {
    dispatch({ type: HomeActions.GET_PRIVACY_POLICY });
    // }
  }, [dispatch]);

  return (
    <div>
      {PrivacyPolicy
        ?.filter((privacyPolicy) => privacyPolicy?.type === "termsandcondition")
        .map((policy, i) => {
          const content = policy?.language?.find(
            (lang) => lang?.language_code === currentLanguage
          )?.content;
          console.log("content", content);

          return (
            <>
              <HTMLRenderer html={content} />
            </>
          );
        })}
    </div>
  );
}
